import * as _ from "lodash";
import * as $ from "jquery";
import {BaseGenericModal, BaseGenericModalOptions} from "./_BaseGenericModal";

interface MaxValuesModalOptions extends BaseGenericModalOptions {
    record: Backbone.Model;
}

export interface MaxValuesOptions {
    max_gateways: string;
    max_nodes: string;
    max_bridges: string;
    max_streams: string;
}

export class MaxValuesModal extends BaseGenericModal {

    public options: MaxValuesModalOptions;
    private template = _.template(require('templates/modals/maxValues.html'));

    constructor(options: MaxValuesModalOptions) {
        super(<any> _.extend({
            tagName: "div",
            events: {
                'shown.bs.modal #maxValuesModal': 'handleModalShown',
                'hidden.bs.modal #maxValuesModal': 'handleModalHidden',
                'click .max-values-input': 'handleSubmit',
                'input .max-values-gateways': 'handleInput',
                'input .max-values-nodes': 'handleInput',
                'input .max-values-bridges': 'handleInput',
                'input .max-values-streams': 'handleInput'
            }
        }, options));
        this.genericIdSelector = 'maxValuesModal';
    }

    render() {
        var text = this.options.text || "Update your max values below:";
        var buttonText = this.options.buttonText || "Update";
        var titleText = this.options.titleText;
        var name = this.options.name || '';

        this.$el.html(this.template({
            elementId: 'maxValuesModal',
            name: name,
            text: text,
            buttonText: buttonText,
            titleText: titleText,
            record: this.options.record
        }));
        return this;
    };

    handleSubmit() {
        var maxGateways = String(this.$('.max-values-gateways').val());
        var maxNodes = String(this.$('.max-values-nodes').val());
        var maxBridges = {
            total: String(this.$('.max-values-bridges.total').val()),
            analog: {
                total: String(this.$('.max-values-bridges.analog.total').val()),
                total_streams: String(this.$('.max-values-bridges.analog.max-streams').val()),
                contact_closure: {
                    total: String(this.$('.max-bridges.max-values-bridges.analog.contact-closure').val()),
                    total_streams: String(this.$('.max-streams.max-values-bridges.analog.contact-closure').val())
                },
                pulse: {
                    total: String(this.$('.max-bridges.max-values-bridges.analog.pulse').val()),
                    total_streams: String(this.$('.max-streams.max-values-bridges.analog.pulse').val())
                },
                ma420: {
                    total: String(this.$('.max-bridges.max-values-bridges.analog.ma420').val()),
                    total_streams: String(this.$('.max-streams.max-values-bridges.analog.ma420').val()),
                },
                thermistor: {
                    total: String(this.$('.max-bridges.max-values-bridges.analog.thermistor').val()),
                    total_streams: String(this.$('.max-streams.max-values-bridges.analog.thermistor').val()),
                },
                volt: {
                    total: String(this.$('.max-bridges.max-values-bridges.analog.volt').val()),
                    total_streams: String(this.$('.max-streams.max-values-bridges.analog.volt').val())
                },
            },
            protocol: {
                total: String(this.$('.max-values-bridges.protocol.total').val()),
                total_streams: String(this.$('.max-values-bridges.protocol.max-streams').val()),
                modbus: {
                    total: String(this.$('.max-bridges.max-values-bridges.protocol.modbus').val()),
                    total_streams: String(this.$('.max-streams.max-values-bridges.protocol.modbus').val()),
                },
                bacnet: {
                    total: String(this.$('.max-bridges.max-values-bridges.protocol.bacnet').val()),
                    total_streams: String(this.$('.max-streams.max-values-bridges.protocol.bacnet').val()),
                },
                water_encoder: {
                    total: String(this.$('.max-bridges.max-values-bridges.protocol.water-encoder').val()),
                    total_streams: String(this.$('.max-streams.max-values-bridges.protocol.water-encoder').val())
                },
            },
            control: {
                total: String(this.$('.max-values-bridges.control.total').val()),
                total_streams: String(this.$('.max-values-bridges.control.max-streams').val()),
                timer: {
                    total: String(this.$('.max-bridges.max-values-bridges.control.timer').val()),
                    total_streams: String(this.$('.max-streams.max-values-bridges.control.timer').val())
                },
            },
            environmental: {
                total: String(this.$('.max-values-bridges.environmental.total').val()),
                total_streams: String(this.$('.max-values-bridges.environmental.max-streams').val()),
                iaq: {
                    total: String(this.$('.max-bridges.max-values-bridges.environmental.iaq').val()),
                    total_streams: String(this.$('.max-streams.max-values-bridges.environmental.iaq').val())
                },
                ieq: {
                    total: String(this.$('.max-bridges.max-values-bridges.environmental.ieq').val()),
                    total_streams: String(this.$('.max-streams.max-values-bridges.environmental.ieq').val())
                }
            }
        };

        var maxStreams = String(this.$('.max-values-streams').val());

        var recordOptions: MaxValuesOptions = {
            max_gateways: maxGateways ? maxGateways : null,
            max_nodes: maxNodes ? maxNodes : null,
            max_bridges: JSON.stringify(maxBridges),
            max_streams: maxStreams ? maxStreams : null
        };

        this.setFormSubmitted();

        $.when(this.options.func(recordOptions)).done(() => {
            this.hide();
        });
    }

    handleModalShown() {
        this.$('.max-values-gateways').focus();
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/modals/MaxValuesModal.ts